export default {
  // SiteNav
  'nav.link1': 'Risk surcharge?',
  'nav.link2': 'Check',
  'nav.link3': 'Letters',
  'nav.menu': 'Menu',

  // HeroSection
  'hero.tag': 'Free · No account · No adviser',
  'hero.title': '<span class="hero-top">You might be paying</span> <span class="accent">too much</span> interest.',
  'hero.lead': 'With many Dutch mortgages, the <strong>risk surcharge</strong> drops automatically when your home increases in value or your debt decreases. But most banks don\'t adjust it on their own. Check in 2 minutes whether you qualify for a lower category, and get a ready-made letter to request it.',
  'hero.cta': 'Start the free check',
  'hero.quote': 'My father-in-law, 86, has been missing out on €73 per month for years. He never reported his WOZ value to the bank.',
  'hero.cite': 'Kees van der Mei<span class="cite-meta"><a href="https://www.linkedin.com/posts/keesvandermei_kan-het-niet-laten-dit-toch-te-delen-heb-share-7461332685165314049-isl3" target="_blank" rel="noopener">on LinkedIn</a>, May 2026</span>',

  // VideoSection
  'video.tag': 'As featured on Radar',
  'video.title': 'How does the risk surcharge work?',
  'video.subtitle': 'Two out of three people in the Netherlands don\'t know what a risk surcharge is — even though it can save you hundreds of euros per year. Radar explains it in 6 minutes (in Dutch).',
  'video.credit': 'Source: Radar — AVROTROS. We have no affiliation with Radar; we show this segment because it explains the risk surcharge clearly.',

  // StatsSection
  'stats.title': 'The numbers',
  'stats.stat1.number': '2 in 3',
  'stats.stat1.label': 'Don\'t know what a risk surcharge is — but are paying one',
  'stats.stat2.number': '€500<span class="small">+</span>',
  'stats.stat2.label': 'Saved per year by 1 in 4 who had their risk surcharge adjusted',
  'stats.stat3.number': '86%',
  'stats.stat3.label': 'Never received an automatic reduction — you have to request it yourself',
  'stats.stat4.label': 'Calculations performed with this tool — {kopieen} letters copied',
  'stats.source': 'Source: <a href="https://radar.avrotros.nl/artikel/honderden-euros-minder-hypotheek-betalen-door-waardestijging-van-je-huis-60890" target="_blank" rel="noopener">Radar 2024 survey</a>',

  // ProcessSection
  'process.title': 'How it works — four steps.',
  'process.subtitle': 'Fully transparent. Below you can see exactly what the tool does with your data.',
  'process.step1.title': 'Your property',
  'process.step1.desc': 'Enter your postcode and house number. We automatically retrieve your WOZ value.',
  'process.step2.title': 'Your mortgage',
  'process.step2.desc': 'Select your lender and enter your outstanding mortgage debt.',
  'process.step3.title': 'Calculation',
  'process.step3.desc': 'We determine your loan-to-value ratio and your risk category.',
  'process.step4.title': 'Letter',
  'process.step4.desc': 'We prepare a pre-filled letter for you. You send it yourself.',

  // ExplainerSection
  'explainer.tag': 'Key terms',
  'explainer.title': 'Let\'s get the terminology straight.',
  'explainer.subtitle': 'The financial world uses a lot of jargon. We use the official terminology as used by the AFM (Dutch Financial Markets Authority), Radar, and the Ministry of Finance.',
  'explainer.term1.term': 'Risk surcharge',
  'explainer.term1.title': 'An add-on to your interest rate',
  'explainer.term1.desc': 'On top of your bank\'s base rate comes a surcharge, depending on the risk the bank takes. The more you\'ve borrowed relative to the value of your home, the higher this surcharge.',
  'explainer.term2.term': 'Loan-to-value ratio',
  'explainer.term2.title': 'Debt ÷ market value',
  'explainer.term2.desc': 'Also known as LTV. With a mortgage of €250,000 on a property worth €425,000, your LTV is 59%. A lower LTV is always better — for you and for the bank.',
  'explainer.term3.term': 'Risk category',
  'explainer.term3.title': 'The bracket you fall into',
  'explainer.term3.desc': 'Banks use categories — for example "up to 60%", "up to 80%", "up to 90%" and "up to 100%". Each category has a different surcharge. If your LTV drops to a lower category, your surcharge can drop too.',

  // StorySection
  'story.tag': 'A real example',
  'story.quote': 'My father-in-law, 86, has been missing out on <span class="highlight">€73 per month</span> for years. He never reported his WOZ value to the bank.',
  'story.cite': 'Kees van der Mei, <a href="https://www.linkedin.com/posts/keesvandermei_kan-het-niet-laten-dit-toch-te-delen-heb-share-7461332685165314049-isl3" target="_blank" rel="noopener">on LinkedIn</a> (May 2026)',

  // WhySection
  'why.tag': 'Our promise',
  'why.title': 'Why is this free?',
  'why.subtitle': 'Because we don\'t earn from banks or advisers. No affiliate links, no lead reselling, no "contact an adviser near you". Fair works.',
  'why.value1.title': 'Independent',
  'why.value1.desc': 'Banks don\'t pay us, and neither do advisers. No affiliate links, no leads sold, no recommendations to call someone. You get information and decide what to do with it yourself.',
  'why.value2.title': 'No account',
  'why.value2.desc': 'No email address, no registration, no tracker that sends you 17 emails afterwards. What you enter stays in your browser and is not stored anywhere.',
  'why.value3.title': 'Open and verifiable',
  'why.value3.desc': 'Our data on risk categories per bank is publicly visible. You can verify for yourself whether we use the correct rates. No hidden logic or black box.',

  // FaqSection
  'faq.tag': 'Frequently asked questions',
  'faq.title': 'Honest answers. Even to difficult questions.',
  'faq.q1.summary': 'Which mortgages does this work for?',
  'faq.q1.answer': 'For most mortgages in the Netherlands without NHG. Mortgages with Nationale Hypotheek Garantie (National Mortgage Guarantee) fall into a separate low-risk category where the loan-to-value ratio doesn\'t matter — a reduction wouldn\'t save you anything. With a savings-linked mortgage (<i>spaarhypotheek</i>), a lower interest rate may actually be disadvantageous because the rate on your savings portion drops as well. Our tool warns you in both cases and recommends consulting an adviser if in doubt.',
  'faq.q2.summary': 'Do all banks accept the WOZ value as proof?',
  'faq.q2.answer': 'No, and our tool indicates this. Some banks (such as parts of ABN AMRO and ASR) require a Calcasa desktop valuation (€110) or a physical appraisal (€600–€800). We show per bank what\'s accepted before you send the letter.',
  'faq.q3.summary': 'Why doesn\'t my bank lower the risk surcharge automatically?',
  'faq.q3.answer': 'The AFM and Consumentenbond have been asking banks to do this automatically for years. Rabobank, Nationale-Nederlanden and a few smaller lenders do so (partly). Many other lenders don\'t adjust it automatically — you have to request it yourself. Radar covered the issue in November 2024, but the topic remains largely under the radar.',
  'faq.q4.summary': 'Do you provide financial advice?',
  'faq.q4.answer': 'No, explicitly not. We provide information based on public data and your input. No recommendations, no bank comparisons, no "we suggest". For advice (e.g., whether switching lenders is wise, or about savings-linked mortgage exceptions), consult an independent mortgage adviser.',
  'faq.q5.summary': 'Do you store my data?',
  'faq.q5.answer': 'No. The calculation happens in your browser. We don\'t store postcodes, debt information, or email addresses. We anonymously count how many people use the check (aggregated, not traceable), so we know whether the tool works. That\'s all.',
  'faq.q6.summary': 'Are you affiliated with Radar?',
  'faq.q6.answer': 'No. We have no relationship with Radar or AVROTROS. We show their broadcast because it clearly explains what a risk surcharge is. Radar also offers their own sample letter.',
  'faq.q7.summary': 'Who is behind this?',
  'faq.q7.answer': 'An independent citizens\' initiative, non-profit and with no ties to banks or mortgage advisers. We work transparently: all risk categories per lender are publicly visible, and the tool runs entirely in your browser. No tracking, no accounts, no hidden revenue model.',

  // BrievenSection
  'brieven.tag': 'Letters & messages',
  'brieven.title': 'Or grab a blank template.',
  'brieven.subtitle': 'Two templates to fill in yourself, without going through the check.',
  'brieven.template1.kind': 'Letter',
  'brieven.template1.title': 'Risk surcharge reduction',
  'brieven.template1.desc': 'Formal letter to request a reduction',
  'brieven.template1.cta': 'Use this template →',
  'brieven.template2.kind': 'Message',
  'brieven.template2.title': 'Risk surcharge reduction',
  'brieven.template2.desc': 'Short message for banking app or chat',
  'brieven.template2.cta': 'Use this template →',

  // ToolSection
  'tool.tag': 'The check',
  'tool.title': 'Takes 2 minutes. No account needed.',
  'tool.subtitle': 'All calculations happen in your browser. We don\'t store anything and we won\'t email you.',
  'tool.errorTitle': 'Some information is missing',

  // ToolForm
  'form.section1.title': 'Your property',
  'form.postcode.label': 'Postcode',
  'form.postcode.placeholder': '1234 AB',
  'form.huisnummer.label': 'House number',
  'form.huisnummer.placeholder': '12',
  'form.toevoeging.label': 'Suffix',
  'form.toevoeging.optional': '(optional)',
  'form.toevoeging.placeholder': 'A',
  'form.addressLoading': 'Looking up address...',
  'form.section2.title': 'Your mortgage',
  'form.section2.subtitle': '— which bank and how much',
  'form.nhg.label': 'Do you have NHG?',
  'form.nhg.hint': 'National Mortgage Guarantee',
  'form.nhg.no': 'No',
  'form.nhg.yes': 'Yes',
  'form.nhg.notice': 'With NHG you already pay the lowest risk surcharge. Requesting a reduction is not necessary.',
  'form.verstrekker.label': 'Which lender holds your mortgage?',
  'form.verstrekker.placeholder': 'Choose your lender...',
  'form.schuld.label': 'What is your current mortgage debt?',
  'form.schuld.hint': 'You can find this on your latest annual statement — the amount you still owe.',
  'form.schuld.placeholder': '€ 250,000',
  'form.wozFallback.title': 'WOZ value',
  'form.wozFallback.subtitle': '— automatic lookup failed',
  'form.wozFallback.hint': 'We couldn\'t retrieve your WOZ value automatically. Enter it manually below. You can find your WOZ value at wozwaardeloket.nl or on your most recent WOZ assessment from your municipality.',
  'form.wozManual.label': 'WOZ value',
  'form.wozManual.placeholder': '€ 350,000',
  'form.submit.loading': 'One moment, we\'re retrieving your WOZ value...',
  'form.submit.calculate': 'Calculate my risk surcharge →',
  'form.disclaimer': 'We don\'t store anything. No account, no email required.',
  'form.error.postcode': 'Enter your postcode.',
  'form.error.huisnummer': 'Enter your house number.',
  'form.error.address': 'Address not found. Check your postcode and house number.',
  'form.error.addressInvalid': 'Enter a valid address.',
  'form.error.verstrekker': 'Choose your lender.',
  'form.error.schuld': 'Enter your mortgage debt.',
  'form.error.woz': 'Enter your WOZ value.',

  // ProcessingSteps
  'processing.step1': 'Checking postcode and retrieving WOZ value...',
  'processing.step2': 'Calculating loan-to-value ratio...',
  'processing.step3': 'Determining risk category based on your lender...',
  'processing.step4': 'Estimating potential savings...',
  'processing.step5': 'Preparing letters...',
  'processing.wozFound': 'WOZ value found:',
  'processing.wozDate': 'reference date',

  // ResultSection
  'result.label': 'You\'re estimated to be overpaying',
  'result.actionTitle': 'What now?',
  'result.actionSubtitle': 'Ask your lender to reduce your risk surcharge.',
  'result.actionBtn': 'Click here to create your letter',
  'result.actionSaving': 'Potential savings:',
  'result.perMonth': '/mo',

  // BriefModal
  'briefModal.close': 'Close',
  'briefModal.howToUseBrief': 'How to use this letter?',
  'briefModal.howToUseMessage': 'How to use this message?',
  'briefModal.copied': '✓ Copied!',
  'briefModal.copy': 'Copy message',

  // CookieBanner
  'cookies.title': 'Cookies — a quick note',
  'cookies.text': 'We use Google Analytics to anonymously measure which parts of the site are used. No personal data. You can change your choice later via the privacy policy.',
  'cookies.reject': 'Decline',
  'cookies.accept': 'Accept',

  // SiteFooter
  'footer.tagline': 'A free tool that shows whether your mortgage interest can be lowered. Without an adviser, without an account, without ads.',
  'footer.disclaimer.title': 'Brief disclaimer',
  'footer.disclaimer.text': 'This is not financial advice. We don\'t compare products and don\'t mediate. Calculations are indicative, based on public rates. Your bank ultimately decides whether a risk surcharge reduction is possible. For advice, consult an independent mortgage adviser.',
  'footer.copyright': '© 2026 minderrente.nl · citizens\' initiative, non-profit',
  'footer.contact': 'Contact',
  'footer.privacy': 'Privacy & disclaimer',

  // ContactPage
  'contact.title': 'Contact',
  'contact.subtitle': 'Have a question, comment, or suggestion? Send us a message.',
  'contact.naam.label': 'Your name',
  'contact.naam.placeholder': 'John Smith',
  'contact.email.label': 'Your email address',
  'contact.email.placeholder': 'john@example.com',
  'contact.bericht.label': 'Message',
  'contact.bericht.placeholder': 'Write your message here...',
  'contact.submit': 'Send message',
  'contact.submitting': 'Sending...',
  'contact.success.title': 'Thank you for your message',
  'contact.success.text': 'We\'ve received your message and you\'ll receive a confirmation by email. We\'ll try to respond as soon as possible.',
  'contact.success.back': 'Back to home',
  'contact.error.naam': 'Enter your name.',
  'contact.error.email': 'Enter your email address.',
  'contact.error.emailInvalid': 'Enter a valid email address.',
  'contact.error.bericht': 'Write a message.',
  'contact.error.submit': 'Something went wrong. Please try again later.',

  // PrivacyPage
  'privacy.title': 'Privacy & Disclaimer',
  'privacy.subtitle': 'How we handle your data and what the tool does and doesn\'t do.',
  'privacy.disclaimer.heading': 'Disclaimer',
  'privacy.disclaimer.intro': 'minderrente.nl is a free information tool. Based on public data and your input, we calculate whether a reduction of the risk surcharge on your mortgage seems possible, and generate a letter you can send to your bank yourself.',
  'privacy.disclaimer.noAdvice': 'No financial advice.',
  'privacy.disclaimer.noAdviceText': 'We don\'t make recommendations about switching your mortgage, about fixed-rate periods, or about specific lenders. We don\'t compare products and don\'t mediate between consumers and banks. For financial advice, consult an independent mortgage adviser or the Consumentenbond.',
  'privacy.disclaimer.indicative': 'Calculations are indicative.',
  'privacy.disclaimer.indicativeText': 'We use the risk categories per lender as publicly known. This data may be outdated or incomplete. Your bank may use a different rate table, apply different conditions for accepting the WOZ value, or apply other exceptions. The estimated savings is an estimate; the actual outcome depends on your bank\'s assessment.',
  'privacy.disclaimer.template': 'The letter is a template.',
  'privacy.disclaimer.templateText': 'You are responsible for the content of the letter you send. Check the details, fill in the missing fields, and only send the letter when you\'re satisfied with the content. We are not liable for rejection, delays, or other consequences of sending the letter.',
  'privacy.disclaimer.independent': 'Independent.',
  'privacy.disclaimer.independentText': 'minderrente.nl is an independent initiative. We have no relationship with mortgage lenders, banks, or financial advisers. There is no commercial interest.',
  'privacy.heading': 'Privacy',
  'privacy.noStorage': 'No storage of personal data.',
  'privacy.noStorageText': 'The postcode, house number, and mortgage details you enter are only processed in your browser. No personal data is stored on our server.',
  'privacy.addressWoz': 'Address and WOZ value.',
  'privacy.addressWozText': 'Your postcode and house number are sent to the PDOK Location Server to look up your address. The found address is then looked up via our server at the public WOZ value register (wozwaardeloket.nl) to retrieve your WOZ value. This data is not logged or stored by us.',
  'privacy.cookies': 'Cookies.',
  'privacy.cookiesText': 'We use Google Analytics to track anonymous visitor statistics, such as the number of visitors and which page sections are used. Google Analytics places cookies on your device. These cookies are only placed if you have given consent via the cookie banner. If you decline cookies, no analytical cookies are placed and no visitor data is collected.',
  'privacy.cookieCardContext': 'Google Analytics anonymously measures which parts of the site are used. No personal data is collected.',
  'privacy.cookieToggleLabel': 'Google Analytics',
  'privacy.cookieRevoke': 'Disable',
  'privacy.cookieAcceptNow': 'Enable',
  'privacy.letters': 'Letters.',
  'privacy.lettersText': 'The letters generated by this tool are composed entirely in your browser. The content is not sent to our server. When you choose "Send by email", your own email client opens — we don\'t send anything on your behalf.',
  'privacy.access': 'Access and correction',
  'privacy.accessText': 'Because we don\'t store personal data, there is nothing to access or correct.',
  'privacy.changes': 'Changes',
  'privacy.changesText': 'If we change this text, we\'ll publish the new version here and update the "Last updated" date below. Substantial changes may be announced via a banner on the homepage.',
  'privacy.lastUpdated': 'Last updated: May 2026',

  // NotFoundPage
  'notFound.title': 'This page doesn\'t exist.',
  'notFound.text': 'The link was mistyped, or we\'ve moved the page.<br>No problem — go back to the homepage and do the check.',
  'notFound.cta': 'Back to minderrente.nl',

  // useBriefGenerator — template metadata
  'brief.title': 'Request to reduce the risk surcharge',
  'brief.subBlanco.brief': 'Blank template — fill in your own details',
  'brief.subBlanco.bericht': 'Blank template — short message for app or chat',
  'brief.subPersonal.brief': 'To {verstrekker} — personalised based on your details',
  'brief.subPersonal.bericht': 'For {verstrekker} — short message for app or chat',
  'brief.mailtoSubject': 'Request to reduce the risk surcharge on my mortgage',

  // Brief template hints
  'brief.hint.blancoBrief': 'This is a blank template. Fill in all yellow and blue fields before sending the letter. Yellow = personal details, blue = mortgage and lender details.',
  'brief.hint.blancoBericht': 'This is a blank message template, intended for your banking app, online banking, or chat function. Copy and paste this text into the correct channel of your lender.',
  'brief.hint.personalBericht': '{verstrekker} processes risk surcharge requests via a digital channel (not email). Copy this message and paste it in the right place — see the hint above the message.',

  // Brief info blocks
  'brief.info.introBlancoBrief': 'This blank template is in formal letter format (paper or email). Suitable for lenders that work via post or a dedicated mortgage email address. Fill in all yellow (personal) and blue (mortgage + lender) fields yourself.',
  'brief.info.introBlancoBericht': 'This blank message template is suitable for lenders that don\'t offer email for mortgage requests. Copy this text and paste it into the app or online banking chat.',
  'brief.info.introPersonalBrief': 'This is a fairly standard request that most lenders process within a few weeks. Fill in the yellow fields yourself before sending. We\'ve pre-filled the blue fields based on your details — check that they\'re correct.',
  'brief.info.introPersonalBericht': '{verstrekker} processes risk surcharge requests via a digital channel (not email). Copy this message and paste it in the right place — see the hint above the message.',
  'brief.info.fillYellow': 'Fill in yourself — yellow',
  'brief.info.fillBlue': 'Fill in yourself — blue',
  'brief.info.fill': 'Fill in yourself',
  'brief.info.computed': 'Pre-filled by us',
  'brief.info.attachment': 'Attachment',
  'brief.info.keepReady': 'Keep at hand',
  'brief.info.personalTitle': 'Personal details',
  'brief.info.personalText': 'Fill in your name, address, and postcode at the top. At the bottom, repeat your name and add your phone number and email address. You can find your mortgage number on your latest annual statement.',
  'brief.info.verstrekkerTitle': 'Lender, WOZ, and mortgage',
  'brief.info.verstrekkerText': 'Fill in the name and address of your lender, plus the WOZ value of your property, your remaining mortgage debt, the calculated LTV, and the risk category you fall into.',
  'brief.info.hypnrTitle': 'Mortgage number and name',
  'brief.info.hypnrText': 'Fill in your mortgage number (found on your annual statement) and your name at the bottom.',
  'brief.info.wozSchuldTitle': 'WOZ and mortgage',
  'brief.info.wozSchuldText': 'Fill in the WOZ value, your remaining debt, your LTV, and the risk category.',
  'brief.info.wozBeschikkingTitle': 'Include your WOZ assessment',
  'brief.info.wozBeschikkingText': 'Request your WOZ assessment from your municipality (via MijnOverheid or the tax office). Attach a copy to this letter; without this attachment, the bank may reject the request.',
  'brief.info.wozBeschikkingBericht': 'Have your WOZ assessment ready (available via MijnOverheid). The bank may ask for an upload or photo as proof.',
  'brief.info.nameAddressTitle': 'Your name and address',
  'brief.info.nameAddressText': 'Fill in your first and last name, your street and house number, and your postcode with city.',
  'brief.info.hypnrPersonalTitle': 'Mortgage number',
  'brief.info.hypnrPersonalText': 'You can find your mortgage number on your latest annual statement or in your online banking environment.',
  'brief.info.wozSchuldPersonalTitle': 'WOZ value and debt',
  'brief.info.wozSchuldPersonalText': 'These details come directly from the form you just filled in.',
  'brief.info.ltvCategorieTitle': 'LTV and risk category',
  'brief.info.ltvCategorieText': 'We calculated the loan-to-value ratio (LTV) by dividing your debt by the WOZ value. Based on that, you fall into a specific risk category of {verstrekker}.',
  'brief.info.wozBeschikkingPersonalText': 'Request your WOZ assessment {peiljaar} from your municipality (online via MijnOverheid). Attach a copy to this letter.',
  'brief.info.wozBeschikkingBerichtText': 'Have your WOZ assessment {peiljaar} ready (available via MijnOverheid or from your municipality).',

  // SEO / Meta
  'meta.title': 'minderrente.nl — Check your risk surcharge. Free. No adviser.',
  'meta.description': 'Many people in the Netherlands pay more mortgage interest than necessary due to an outdated risk surcharge. Check in 2 minutes whether you qualify for a lower category and get a ready-made letter to request it.',
  'meta.ogTitle': 'minderrente.nl — Check your risk surcharge',
  'meta.ogDescription': 'You might be paying too much mortgage interest. Check in 2 minutes whether your surcharge can be lowered and get a ready-made letter right away.',
}
